import { createApiRef } from '@backstage/frontend-plugin-api';

export interface SignOutHooksApi {
  /** Enregistre une action à exécuter avant la déconnexion. Renvoie la désinscription. */
  register(hook: () => Promise<void>): () => void;
  /** Exécute toutes les actions ; une action qui échoue n'empêche pas les autres. */
  runAll(): Promise<void>;
}

/**
 * Les modules qui gardent une session côté serveur (Keycloak) y enregistrent
 * de quoi la fermer ; c'est le contrôle de déconnexion de l'application
 * (`packages/app`, `SignOutButton`) qui les exécute, avant `identityApi.signOut()`. La
 * déconnexion native d'un Backstage nu ne les appelle pas (réservé au
 * chantier 3). Les
 * consommateurs lisent l'API de façon optionnelle (`useApiHolder`) : la
 * déconnexion ne doit jamais dépendre de la présence d'un plugin.
 */
export const signOutHooksApiRef = createApiRef<SignOutHooksApi>({
  id: 'plugin.platform.sign-out-hooks',
});
